(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.custom-collection-slider');
  if (!slider) return;

  const wrapper = slider.querySelector('.slider-wrapper');
  const prev = slider.querySelector('.slider-prev');
  const next = slider.querySelector('.slider-next');
  let items = Array.from(wrapper.querySelectorAll('.slider-item'));
  if (items.length === 0) { prev.style.display = next.style.display = 'none'; return; }

  // Helpers
  const parseGap = () => {
    const g = getComputedStyle(wrapper).gap;
    return g ? parseFloat(g) : 0;
  };

  const itemsToShow = () => window.innerWidth <= 768 ? 2 : 4;

  const getSlideWidth = () => {
    const gap = parseGap();
    let w = items[0].getBoundingClientRect().width;
    if (!w || w < 1) {
      w = Math.max(1, (wrapper.clientWidth - gap * (itemsToShow() - 1)) / itemsToShow());
    }
    return Math.round(w + gap);
  };

  const getMaxIndex = () => Math.max(0, items.length - itemsToShow());

  const getCurrentIndex = () => {
    const slideW = getSlideWidth();
    if (slideW === 0) return 0;
    return Math.round(wrapper.scrollLeft / slideW);
  };

  function updateArrows() {
    if (items.length <= itemsToShow()) {
      prev.style.display = 'none';
      next.style.display = 'none';
      return;
    }

    const maxIndex = getMaxIndex();
    const idx = getCurrentIndex();

    if (idx <= 0) {
      prev.style.display = 'none';
      next.style.display = 'block';
    } else if (idx >= maxIndex) {
      prev.style.display = 'block';
      next.style.display = 'none';
    } else {
      prev.style.display = 'block';
      next.style.display = 'block';
    }
  }

  let raf = null;
  wrapper.addEventListener('scroll', () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      updateArrows();
      raf = null;
    });
  });

  prev.addEventListener('click', () => {
    const slideW = getSlideWidth();
    const cur = getCurrentIndex();
    const targetIndex = Math.max(0, cur - 1);
    wrapper.scrollTo({ left: targetIndex * slideW, behavior: 'smooth' });
  });

  next.addEventListener('click', () => {
    const slideW = getSlideWidth();
    const cur = getCurrentIndex();
    const maxIndex = getMaxIndex();
    const targetIndex = Math.min(maxIndex, cur + 1);
    wrapper.scrollTo({ left: targetIndex * slideW, behavior: 'smooth' });
  });

  let isPointerDragging = false;
  let pointerStartX = 0;
  let pointerStartScroll = 0;

  wrapper.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'touch') return;
    isPointerDragging = true;
    wrapper.setPointerCapture(e.pointerId);
    pointerStartX = e.clientX;
    pointerStartScroll = wrapper.scrollLeft;
    wrapper.classList.add('dragging');
    e.preventDefault();
  });

  wrapper.addEventListener('pointermove', (e) => {
    if (!isPointerDragging) return;
    const dx = e.clientX - pointerStartX;
    wrapper.scrollLeft = pointerStartScroll - dx;
  });

  wrapper.addEventListener('pointerup', (e) => {
    if (!isPointerDragging) return;
    isPointerDragging = false;
    try { wrapper.releasePointerCapture(e.pointerId); } catch (err) {}
    wrapper.classList.remove('dragging');

    const slideW = getSlideWidth();
    const idx = Math.round(wrapper.scrollLeft / slideW);
    const clamped = Math.max(0, Math.min(getMaxIndex(), idx));
    wrapper.scrollTo({ left: clamped * slideW, behavior: 'smooth' });
  });

  wrapper.addEventListener('pointercancel', () => {
    if (!isPointerDragging) return;
    isPointerDragging = false;
    wrapper.classList.remove('dragging');
  });

  window.addEventListener('resize', () => {
    items = Array.from(wrapper.querySelectorAll('.slider-item'));
    const slideW = getSlideWidth();
    const idx = getCurrentIndex();
    const clamped = Math.max(0, Math.min(getMaxIndex(), idx));
    wrapper.scrollTo({ left: clamped * slideW, behavior: 'smooth' });
    updateArrows();
  });

  window.addEventListener('load', () => {
    items = Array.from(wrapper.querySelectorAll('.slider-item'));
    setTimeout(() => {
      updateArrows();
    }, 60);
  });

  setTimeout(updateArrows, 50);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
